module.exports = __webpack_public_path__ + "static/img/1.c577fb23.png";